'use strict';
import angular from 'angular';

import createRateCardHtmlUrl from 'ioToolViews/admin/createRateCard.html';

angular.module('ratecard.ctrls', [])
    .controller('RateCardController', RateCardController);

RateCardController.$inject = ['$scope', 'ProductService', '$modal', '$ioAlert', '$state'];
function RateCardController ($scope, ProductService, $modal, $ioAlert, $state){
    $scope.rateCards = [];
    var getRateCards = function() {
        $scope.rateCardContents = [
            {ad_size: '760x250', ad_type: 'Interstitial', placement: 1, delivery: 'CPM', floor: '$2.00', discount: '5%', exception: 'approval_task', start_date: '11/1/2012', end_date: '<never>', active: true},
            {ad_size: '728x90', ad_type: 'Leaderboard', placement: 2, delivery: 'CPM', floor: '$5.00', discount: '7%', exception: 'block', start_date: '11/1/2012', end_date: '<never>', active: true},
            {ad_size: '300x600', ad_type: 'Half Page', placement: 3, delivery: 'fixed', floor: '$12.00', discount: '5%', exception: 'approval_task', start_date: '11/1/2012', end_date: '<never>', active: true},
            {ad_size: '1200x900', ad_type: 'Full Page', placement: 4, delivery: 'CPM', floor: '$150.00', discount: '8%', exception: 'warn', start_date: '11/1/2012', end_date: '<never>', active: true},
            {ad_size: '760x250', ad_type: 'Interstitial', placement: 5, delivery: 'fixed', floor: '$1.00', discount: '5%', exception: 'notify', start_date: '11/1/2012', end_date: '<never>', active: true},
        ]
        $scope.rateCards = [
            {id: 1, name: 'Scripps Media Display', active: true},
            {id: 2, name: 'Google Search', active: true},
            {id: 3, name: 'Scripps Network', active: true}

        ];
    };

    //TODO: Once this module has been spec'd and figured out to completion, move the necessary modals to the modals module
    var showModal = function(rateCard) {
        return $modal.open({
            controller: function($scope, $modalInstance, rateCard) {
                $scope.rateCardObj = {};
                if (rateCard) {
                    $scope.rateCardObj.name = rateCard.name;
                    $scope.rateCardObj.id = rateCard.id;
                    $scope.rateCardObj.content_key = rateCard.content_key;
                    $scope.rateCardObj = "Update";
                } else {
                    $scope.rateCardObj = "Create New";
                }
                $scope.addRateCard = function(rateCard) {
                    $scope.rateCards.push(rateCard);
                }

                $scope.cancel = function() {
                    $modalInstance.dismiss();
                }
            },
            templateUrl: createRateCardHtmlUrl,
            resolve: {
                rateCard: function() {
                    return rateCard;
                }
            },
            backdrop: 'static'
        });
    }

    $scope.backToRateCards = function() {
        $state.go('ratecard')
    };

    //TODO: Once this module has been spec'd and figured out to completion, move the necessary modals to the modals module
    $scope.addCard = function(rateCard) {
        var modalObj = showModal(rateCard);
        if (rateCard) {
            $scope.isNew = false;
        } else {
            $scope.isNew = true;
        }
        modalObj.result.then(function(formObj) {
            var param = formObj;
            if ($scope.isNew) {
                $scope.rateCards.push(data);
                $ioAlert.show('Hola', 'Lookup type created successfully', 'success');
            } else {
                ProductService.updateLookupType(param).then(function(data) {
                    for (var i = 0, len = $scope.rateCards.length; i < len; i++) {
                        if ($scope.rateCards[i].id == data.id) {
                            $scope.rateCards[i] = data;
                        }
                    }
                    $ioAlert.show('Hola', 'Rate Card updated successfully', 'success');
                }, function() {
                    console.log("error updating Rate Card");
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                });
            }
        }, function() {
            console.log("cancel");
        })

    };

    $scope.viewContents = function(rateCard) {
        $state.go('rateCardContent', {
            'typeId': rateCard.id
        })
    }

    $scope.init = function() {
        getRateCards();
    };

    $scope.init();

}